module.exports = __webpack_public_path__ + "img/bell-alt.deb59578.svg";